// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* 84 = navbar + tags-view = 50 + 34 */\n/* 50= navbar  50  */", ""]);
// Exports
exports.locals = {
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "#304156",
	"menuHover": "#263445",
	"subMenuBg": "#1f2d3d",
	"subMenuHover": "#001528",
	"sideBarWidth": "210px",
	"creativeResourceMediaCompSize": "200px",
	"phoneWidth": "640px",
	"tabletWidth": "768px",
	"desktopWidth": "1024px"
};
module.exports = exports;
